import React, { useState, useContext } from "react";
import { AuthContext } from "../../Auth/AuthContext";
import ApplicationD from "./Application/ApplicationD";
import ApplicationStatus from "./Application/ApplicationStatus";
import AdminImageUpload from './Application/AdminImgupload'

function ApplicationServices() {
  const { auth } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("app_download");
  useState(() => {
    if (auth.user.accesslvl === "S") {
      setActiveTab("app_status");
    }
  }, [auth]);
  return (
    <div>
      <div
        style={{ display: "flex", flexDirection: "column", flexWrap: "wrap" }}
      >
        <div
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          <div className="tabs">
            {auth.user.accesslvl !== "S" && (<>
              <button
                className={`tab-btn ${activeTab === "app_download" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("app_download")}
              >
                Application
              </button>
              <button
                className={`tab-btn ${activeTab === "app_status" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("app_status")}
              >
                Application Status
              </button>
              <button
                className={`tab-btn ${activeTab === 'app_img_status' ? 'active' : ''}`}
                onClick={() => setActiveTab('app_img_status')}
              >
                Image upload
              </button>
            </>
            )}



          </div>
        </div>
        {auth.user.accesslvl !== "S" && (
          <>
            {activeTab === "app_download" && (
              <div className="app-service-container">
                <ApplicationD />
              </div>
            )}
            {activeTab === 'app_img_status' && (
              <div className='app-service-status-container'>
                <AdminImageUpload />
              </div>
            )}
          </>
        )}

        {activeTab === "app_status" && (
          <div className="app-service-status-container">
            <ApplicationStatus />
          </div>
        )}

      </div>
      <div>
        {/* <div className='service-container'>
                    <HandleSchedule />
                </div> */}
      </div>
    </div>
  );
}

export default ApplicationServices;
